module.exports = __webpack_public_path__ + "static/media/highscore.d2e63699.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/highscore.png
// module id = 1724
// module chunks = 27